<template>
  <div class="password-recovery">
    <SignBanner result="change_password" />
    <ModalComponentBody>
      <SignTitle>
        {{ messages?.resetPassword }}
      </SignTitle>
      <SignText>
        {{ text }}
      </SignText>
      <form class="password-recovery-form" @submit.prevent="handlerSubmit">
        <input type="hidden" name="email" :value="email" />
        <DefInput
          name="checkWord"
          required
          :placeholder="messages.confirmationText"
          :is-error="Boolean(errors && errors.forgetPasswordRecovery)"
          :is-show-error="Boolean(errors && errors.forgetPasswordRecovery)"
          :error-text="errors.forgetPasswordRecovery"
        />
        <DefInputPassword name="password" :placeholder="messages.password" required />
        <DefInputPassword name="confirmPassword" :placeholder="messages.confirmPassword" required />

        <DefButtonPrimary type="submit">
          {{ messages?.savePassword }}
        </DefButtonPrimary>

        <DefButtonSecondary type="button" @click="handlerOpenModal">
          {{ messages?.cancel }}
        </DefButtonSecondary>
      </form>
    </ModalComponentBody>
  </div>
</template>

<script lang="ts" setup>
import SignBanner from '@components/Cabinet/Entry/SignBanner.vue';
import ModalComponentBody from '@use/useModal/ModalComponentBody.vue';
import SignTitle from '@components/Cabinet/Entry/SignTitle.vue';
import { useStore } from '@/store';
import { computed } from 'vue';
import SignText from '@components/Cabinet/Entry/SignText.vue';
import DefInput from '@components/Def/DefInput/DefInput.vue';
import DefInputPassword from '@components/Def/DefInput/DefInputPassword.vue';
import DefButtonSecondary from '@components/Def/DefButtonSecondary/DefButtonSecondary.vue';
import SignIn from '@components/Cabinet/Entry/SignIn/SignIn.vue';
import useModal from '@use/useModal/useModal';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import Recaptcha3 from '@/utils/Recaptcha3';

const { state, dispatch } = useStore();
const messages = computed(() => state.results?.messages?.entry);

const props = defineProps<{ email: string; text: string }>();
const errors = computed(() => state.personal.data?.errors);

const modal = useModal();

const handlerSubmit = async (e: SubmitEvent) => {
  const formData: FormData = new FormData(e.target as HTMLFormElement);

  const token = await Recaptcha3.getSubmitToken();
  formData.append('g-recaptcha-response', token);

  const response = await dispatch('personal/doPasswordRecoveryByCheckWordAndEmail', formData);
  if (response.status === true) {
    window.location.reload();
  }
};

const handlerOpenModal = async () => {
  modal.show(
    SignIn,
    {},
    {
      width: '900px',
      backgroundClose: false,
    }
  );
};
</script>

<style lang="scss" scoped>
.password-recovery {
  @include point-md {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.password-recovery-form {
  display: grid;
  grid-row-gap: 12px;
  :deep(.def-button-primary) {
    margin-top: 4px;
  }
}
</style>
